<!-- 払い戻し画面のアクションボタン -->
<template>
  <div>
    <div class="actions">
      <!-- 払い戻す -->
      <ItemButton
        v-if="bookGroup.payment_status === 'paid'"
        :label="$t('MyTicketTicketing.refund')"
        action-type="btn-primary"
        @clicked="executeRefund"
      />

      <!-- 戻る -->
      <ItemButton
        :label="$t('common.backButtonLabel')"
        action-type="btn-cancel"
        @clicked="backToPreviousPage"
      />
    </div>

    <!-- 払い戻しローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />

    <!-- Refund confirmation dialog -->
    <DialogBookRefundConfirmation
      ref="DialogBookRefundConfirmation"
      :execute-refund="confirmRefund"
    />

    <!-- 払い戻し完了ダイアログ-->
    <DialogBookRefundComplete ref="DialogBookRefundComplete" />

    <DialogBookInDirectRefundComplete ref="DialogBookInDirectRefundComplete" />

    <!-- 払い戻しエラー時のダイアログ -->
    <DialogBookRefundError ref="DialogBookRefundError" />
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";
import DialogBookRefundComplete from "@/views/Components/Organisms/MyTickets/Dialog/DialogBookRefundComplete";
import DialogBookRefundError from "@/views/Components/Organisms/MyTickets/Dialog/DialogBookRefundError";
import DialogBookRefundConfirmation from "@/views/Components/Organisms/MyTickets/Dialog/DialogBookRefundConfirmation";

import API from "@/API";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "TheBookRefundFooter",
  components: {
    DialogLoading: DialogLoading,
    DialogBookRefundConfirmation: DialogBookRefundConfirmation,
    DialogBookRefundComplete: DialogBookRefundComplete,
    DialogBookRefundError: DialogBookRefundError,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogLoading = ref(null);
    const DialogBookRefundConfirmation = ref(null);
    const DialogBookRefundComplete = ref(null);
    const DialogBookInDirectRefundComplete = ref(null);
    const DialogBookRefundError = ref(null);

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);

    const executeRefund = async () => {
      DialogLoading.value.openDialog();
      try {
        //in-direct refund
        if (book.value.refundable == false) {
          DialogLoading.value.closeDialog();
          //confirm in-direct refund
          DialogBookRefundConfirmation.value.openDialog();
        } else {
          // 払い戻し実行
          await API.refundBookGroup(route.params.book_group_id);

          // 最新ブックグループを取得
          await API.getMyticketDetail(route.params.book_group_id);

          nativeHandlerService.ncTicketRefund(bookGroup.value.id);

          DialogLoading.value.closeDialog();
          DialogBookRefundComplete.value.openDialog();
        }
      } catch (err) {
        DialogLoading.value.closeDialog();
        DialogBookRefundError.value.openDialog();
        console.log("err :>> ", err);
      }
    };
    //for in-direct refund
    const confirmRefund = async () => {
      DialogLoading.value.openDialog();
      try {
        //todo: new specification for in-direct refund api

        //in direct refund: change payment status
        await API.refundBookGroup(route.params.book_group_id);

        // 最新ブックグループを取得
        await API.getMyticketDetail(route.params.book_group_id);

        nativeHandlerService.ncTicketRefund(bookGroup.value.id);

        DialogLoading.value.closeDialog();
        DialogBookInDirectRefundComplete.value.openDialog();
      } catch (err) {
        DialogLoading.value.closeDialog();
        DialogBookRefundError.value.openDialog();
        console.log("err :>> ", err);
      }
    };

    // 前の画面に戻る
    const backToPreviousPage = async () => {
      router.go(-1);
    };

    return {
      bookGroup,
      executeRefund,
      confirmRefund,
      backToPreviousPage,
      DialogLoading,
      DialogBookRefundConfirmation,
      DialogBookRefundComplete,
      DialogBookInDirectRefundComplete,
      DialogBookRefundError,
    };
  },
};
</script>
